<div class="info-strip grid clearfix">
  <div class="info-strip-left grid">
    <button class="back-button" type="button" (click)="back('/rec-name-search')">
      <i class="fa fa-caret-left"></i><p>Back</p>
    </button>
  </div>
  <div class="info-strip-right grid">
    <div class="criteria">
      <h2>Name Variation Search Results</h2>
      <p>
         <strong>{{recordCount}}</strong> records found
      </p>
    </div>
  </div>
</div>
